import getAxiosInstance from '../../helpers/get_axios_instance'
import lrsAdapter from '../../helpers/lrs_adapter'

class PesoDestare {
  static altaPesado (destareValues = {}) {
    const {
      fechaCalado,
      numero,
      balanza
    } = destareValues
    const axios = getAxiosInstance()
    const promise = axios.post(`carga_entrante_automotor_con_neto`,
      `{"valores": {"fecha_de_calado": "${fechaCalado}", "carta_de_porte_automotor": "${numero}", 
      "balanza_de_destare": "${balanza}" }}`)
    return promise.then(lrsAdapter, lrsAdapter)
      .then((result) => { return result })
  }

  static altaPesadoManual (destareValues = {}) {
    const {
      fechaCalado,
      numero,
      balanza,
      pesoDestare
    } = destareValues
    const axios = getAxiosInstance()
    const promise = axios.post(`carga_entrante_automotor_con_neto`,
      `{"valores": {"fecha_de_calado": "${fechaCalado}", "carta_de_porte_automotor": "${numero}", 
      "balanza_de_destare": "${balanza}", "peso_tara": "${pesoDestare}" }}`)
    return promise.then(lrsAdapter, lrsAdapter)
      .then((result) => { return result.data[0] })
  }

  static repeso (destareValues = {}) {
    const {
      fechaCalado,
      numero
    } = destareValues
    const axios = getAxiosInstance()
    const promise = axios.put(`carga_entrante_automotor_con_neto`,
      `{"valores": {"fecha_de_calado": "${fechaCalado}"}, 
    "clave": {"carta_de_porte_automotor": "${numero}"}}`)
    return promise.then(lrsAdapter, lrsAdapter)
      .then((result) => { return result.data[0] })
  }

  static repesoManual (destareValues = {}) {
    const {
      fechaCalado,
      numero,
      pesoDestare
    } = destareValues
    const axios = getAxiosInstance()
    const promise = axios.put(`carga_entrante_automotor_con_neto`,
      `{"valores": {"fecha_de_calado": "${fechaCalado}", "peso_tara": "${pesoDestare}"}, 
    "clave": {"carta_de_porte_automotor": "${numero}"}}`)
    return promise.then(lrsAdapter, lrsAdapter)
      .then((result) => { return result.data[0] })
  }

  static updateCerealAdherido (numero, cerealAdherido) {
    const axios = getAxiosInstance()
    const promise = axios.put(`carga_entrante_automotor_con_neto`,
      `{"valores": {"cereal_adherido": "${cerealAdherido}"}, 
    "clave": {"carta_de_porte_automotor": "${numero}"}}`)
    return promise.then(lrsAdapter, lrsAdapter)
      .then((result) => { return result.data[0] })
  }

  static getUltimoPesadoDestare () {
    const axios = getAxiosInstance()
    const promise = axios.get(`carga_entrante_automotor_con_neto?r=` +
       `{"limite":1, "orden": ["d:fecha_de_destare"]}`)
    return promise.then(lrsAdapter, lrsAdapter)
      .catch(lrsAdapter)
      .then((result) => { return result.data[0] })
  }

  static escribirPesoDestare (peso) {
    const axios = getAxiosInstance()
    const promise = axios.get(`escribir_peso_destare?r=` +
      `{"parametros": { "peso": "${peso}"}}`)
    return promise.then(lrsAdapter, lrsAdapter)
      .catch(lrsAdapter)
      .then((result) => { return result.data })
  }
}

export default PesoDestare
